import * as React from 'react';
import ProgressBar from "./ProgressBar";
import useTranslation from "../../../utils/hooks/translation";
var Pagination = function Pagination(_ref) {
  var showing = _ref.showing,
    totalResults = _ref.totalResults,
    className = _ref.className,
    onClick = _ref.onClick,
    buttonText = _ref.buttonText,
    isLoading = _ref.isLoading,
    disabled = _ref.disabled;
  var t = useTranslation();
  return /*#__PURE__*/React.createElement("div", {
    className: "text-center ".concat(className)
  }, /*#__PURE__*/React.createElement("p", {
    className: "pagination__text"
  }, t('paginationShowing'), " ", showing, " ", t('paginationShowingOf'), ' ', totalResults), /*#__PURE__*/React.createElement("div", {
    className: "pagination__progress-bar"
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    showingNow: showing,
    totalResult: totalResults
  })), showing > 0 && /*#__PURE__*/React.createElement("button", {
    className: "button",
    onClick: onClick,
    disabled: isLoading || disabled
  }, buttonText));
};
export default Pagination;